import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_GROUPS: '/GetGroups',
  CREATE_GROUP: '/CreateGroup',
  DELETE_GROUP: '/GroupDelete',
  UPDATE_GROUP: '/UpdateGroup'
};

export const getAllGroups = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_GROUPS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};

export const createGroup = async (userData) => {
  try {
    const formData = new FormData();
    formData.append('Name', userData.name);
    formData.append('IsActive', true);

    const response = await axiosInstance.post(ENDPOINTS.CREATE_GROUP, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to create user');
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

export const deleteGroup = async (userId) => {
  try {
    const response = await axiosInstance.delete(`${ENDPOINTS.DELETE_GROUP}/${userId}`);
    if (response.data && response.data.status === 200) {
      return 1;
    }
    return 0;
  } catch (error) {
    return 0;
  }
};

export const updateGroups = async (userId, userData) => {
  try {
    const formData = new FormData();
    formData.append('Name', userData.name);   
    formData.append('IsActive', userData.isActive);

    const response = await axiosInstance.put(`${ENDPOINTS.UPDATE_GROUP}/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to update user');
  } catch (error) {
    console.error('Update user error:', error);
    throw error;
  }
};
